import React from 'react'
import useSessionStorage from '@helpers/hooks/useSessionStorage'
import { ReactComponent as CloseIcon } from '@svgs/keyline/close.svg'
import BookCustomerService, { BookCustomerServiceProps } from './index'
import styles from './styles.module.scss'

type BookCustomerServiceDismissibleProps = BookCustomerServiceProps & {
  children: React.ReactNode
}

export default function BookCustomerServiceDismissible({
  children,
  ...props
}: BookCustomerServiceDismissibleProps) {
  const [isVisible, setIsVisible] = useSessionStorage(
    'bookCustomerService',
    true
  )
  return (
    <>
      {isVisible && (
        <BookCustomerService {...props}>
          {children}
          <button
            type="button"
            className={styles.bookCustomerService__closeButton}
            onClick={() => setIsVisible(false)}
          >
            <CloseIcon />
          </button>
        </BookCustomerService>
      )}
    </>
  )
}
